<template>
 <div>
    <v-snackbar v-model="feedback.show" :color="feedback.color" top timeout="10000">
          <v-row justify="space-between">
            {{ feedback.text }}
              <div>
                <v-btn v-if="feedback.color === 'error'" class="ml-2" @click="showHelpDilog = true" icon color="white">
               <v-icon color="white">mdi-help-circle-outline</v-icon>
              </v-btn>
              <v-btn @click="hideFeedback" icon color="white">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
              </div>
          </v-row>
     </v-snackbar>
     <v-dialog v-model="showHelpDilog" max-width="600">
        <v-card max-width="600">
          <v-card-title class="darkBlue--text">Tell Us About Your Issue</v-card-title>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="description"
                outlined
                label="Please describe the problem in detail"
              />
              <v-file-input
                v-model="attachment"
                truncate-length="15"
                outlined
                prepend-icon=""
                label="Add an attachment (screenshot, document, etc.)"
              />
              <v-btn
                block
                color="indigo"
                class="white--text"
                :disabled="!description"
                @click="reportEmail"
              >
                Submit
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
 </div>
</template>
<script>
import { mapState } from 'vuex'
import { headersAuth, reportIssue } from '../links'
export default {
  name: 'snack bar',
  computed: {
    ...mapState(['feedback'])
  },
  data () {
    return {
      showHelpDilog: false,
      description: null,
      attachment: null
    }
  },
  watch: {
    feedback: {
      handler (newVal) {
        this.description = newVal.text
      },
      immediate: true
    }
  },
  methods: {
    reportEmail () {
      console.log('test props', this.feedback)
      const formData = new FormData()
      formData.append('description', this.description)
      formData.append('attachment', this.attachment)
      formData.append('request_payload', JSON.stringify(this.feedback.requestedData))
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      this.$http.post(reportIssue, formData, header)
        .then(response => response.json())
        .then(response => {
          if (response.errors) {
            this.text = response.message
            this.color = 'error'
            this.snackbar = true
          }
          console.log(response)
          this.text = response.message
          this.color = 'success'
          this.snackbar = true
          this.showHelpDilog = false
        }).catch(err => {
          this.$store.commit('showFeedback', { text: err?.body?.message, color: 'error', requestedData: formData })
        })
    },
    hideFeedback () {
      this.$store.commit('hideFeedback')
    }
  }
}
</script>
